import { Check } from '@chain-zen/ui'

import { TiveIcon } from '../tive-icon'
import { TrackingSourceRow } from '../tracking-source-row'
import { TrackingTimeDisplay } from '../tracking-time-display'
import type { IAPISourceProps } from '../types'

/**
 * Displays the details for API tracking source
 */
export const APIInfo = (props: IAPISourceProps) => {
  const { trackingSourceData } = props
  const lastLocation = trackingSourceData?.locations?.[trackingSourceData.locations.length - 1]

  return (
    <TrackingSourceRow className="px-2">
      <div className="flex items-center gap-1 flex-wrap">
        <Check className="h-3 w-3 shrink-0 self-center text-green-500 dark:text-green-400" />
        <TiveIcon size={3} />
        <span className="text-sm font-medium text-foreground">
          Tracking sent by {trackingSourceData.source || 'carrier'} via API
        </span>
        {!!lastLocation && (
          <TrackingTimeDisplay
            className="flex items-center gap-1 text-xs text-muted-foreground"
            filterReason={trackingSourceData.filterReason}
            lastLocationCity={lastLocation.city}
            lastLocationFetchedAt={trackingSourceData.lastLocationFetchedAt}
            lastLocationStateCode={lastLocation.stateCode}
            lastLocationTimestamp={lastLocation.timestamp}
            wrapper="div"
          />
        )}
      </div>
    </TrackingSourceRow>
  )
}
